var ErrorService = /** @class */ (function () {
    function ErrorService() {
        this.errors = [];
    }
    ErrorService.prototype.hasErrors = function () {
        return this.errors.length > 0;
    };
    ErrorService.prototype.addError = function (error) {
        var found = this.errors.find(function (e) { return e.message === error.message; });
        if (!found) {
            this.errors.push(error);
        }
    };
    ErrorService.prototype.getErrors = function () {
        return this.errors;
    };
    ErrorService.prototype.clearErrors = function () {
        this.errors.length = 0;
    };
    return ErrorService;
}());
export { ErrorService };
